module.exports = __webpack_public_path__ + "static/media/YM12_0.cfb79615.jpg";